import { getDataProcy } from '../../apis//util';
import { getCookieAmend } from '../../util/cookie';
import { isArray, reportEvent } from '../../util/util';

const reportedChannelId = [];

const posterWidthArr = {
  HomeTab: 850,
  OtherTab: 556,
  History: 408,
  Column: 408,
};

const posterHeightArr = {
  HomeTab: 364,
  OtherTab: 314,
  History: 230,
  Column: 272,
};

const posterLengthArr = {
  HomeTab: 2,
  OtherTab: 3,
  History: 3,
  Column: 6,
};

const rumReport = ({
  eventName,
  channelId,
}) => {
  reportEvent({
    name: eventName, // 埋点名称
    ext2: {
      channelId,
    },
  });
};

const getDataProcyAsync = async({
  channelId,
  pageCtx,
  body,
  firstGet,
}) => {
  const result = await getDataProcy({
    key: 'GetHomePage',
    keys: [{ key: 'channelId', value: channelId }, { key: 'pageCtx', value: pageCtx }, { key: 'langCode', value: getCookieAmend('lang_code') }],
    body,
    params: {},
    isFirstEnter: firstGet,
  }).then((res) => {
    let navigation = [];
    let country = '';
    let hasNextPage = false;
    if (res.code === 0) {
      country = res?.data?.country || country;
      hasNextPage = res?.data?.has_next_page;
      // eslint-disable-next-line
      pageCtx = res?.data?.page_ctx || pageCtx;
      navigation = res?.data?.navigation || navigation;
      // 如果没有个人中心tab栏，则手动添加
      navigation.length && navigation[0].channel.page_type !== 3 && navigation.unshift({
        channel: {
          id: '10215',
          name: '个人中心',
          page_type: 3,
          user_choice: { first_category: 'All' },
        },
        child_nodes: [],
      });
      // eslint-disable-next-line
      channelId = getChannelId({
        firstGet,
        navigation,
        channelId,
      });
      const modules = res?.data?.modules || [];
      const { column, history, poster } = handleModule({
        modules,
        // 是否是mine tab旁边的tab
        firstGet: firstGet || navigation[1]?.channel?.id === channelId,
      });
      const result = {
        column,
        history,
        poster,
        navigation,
        country,
        hasNextPage,
        pageCtx,
        channelId,
        curNav: navigation.find(item => item?.channel?.id === channelId),
      };
      saveNavigations({
        channelId,
        result,
      });
      return channelId;
    }
    return null;
  })
    .catch(_err => null);
  return result;
};

export const getHomePageData = async ({
  firstGet,
  channelId = '',
  pageCtx = '',
}) => {
  const body = {
    channel_id: channelId,
    page_ctx: pageCtx,
  };
  const isReported = reportedChannelId.includes(channelId);
  if (!firstGet && !isReported) {
    rumReport({
      eventName: 'homePage_CheckTab ',
      channelId,
    });
    reportedChannelId.push(channelId);
  }
  const getNavigation = getNavigations(channelId);
  if (Object.keys(getNavigation)?.length) {
    saveNavigations({
      channelId,
      result: getNavigation,
    });
    if (!isReported) {
      rumReport({
        eventName: 'homePage_CheckTab_UseTheCache',
        channelId,
      });
    }
    getDataProcyAsync({
      channelId,
      pageCtx,
      body,
      firstGet,
    });
    return getNavigation?.channelId;
  };
  // 请求获取数据
  return await getDataProcyAsync({
    channelId,
    pageCtx,
    body,
    firstGet,
  });
};

export const getNextPageData = ({
  channelId,
  pageCtx,
}) => {
  const body = {
    channel_id: channelId,
    page_ctx: pageCtx,
  };
  // 请求获取数据
  return getDataProcy({
    key: 'GetHomePage',
    keys: [{ key: 'channelId', value: channelId }, { key: 'pageCtx', value: pageCtx }, { key: 'langCode', value: getCookieAmend('lang_code') }],
    body,
    params: {},
    isFirstEnter: false,
  }).then((res) => {
    let hasNextPage = false;
    let pageCtx = '';
    if (res.code === 0) {
      hasNextPage = res?.data?.has_next_page;
      pageCtx = res?.data?.page_ctx || pageCtx;
      const modules = res?.data?.modules || [];
      const column = handleModuleColumn(modules);
      return {
        column,
        hasNextPage,
        pageCtx,
      };
    }
    return null;
  })
    .catch(_err => null);
};

const handleModule = (props) => {
  const { modules, firstGet } = props;
  let poster = {
    moduleName: 'poster',
    curFocusIdx: 0,
  };
  let history = {
    moduleName: 'history',
    curFocusIdx: 0,
  };
  const column = [];
  modules.forEach((module, Idx) => {
    const {
      // item_pic_aspect_ratio: ratio,
      name,
      // row_count: rowCount,
      items,
      type,
    } = module;
    if (type === 1) {
      // type 为 1时是第一行海报 poster
      const key = firstGet ? 'HomeTab' : 'OtherTab';
      const posterEndIdx = posterLengthArr[key];
      const posterWidth = posterWidthArr[key];
      const posterHeight = posterHeightArr[key];
      // HomeTab 和 OtherTab
      poster = {
        name,
        mod_pos: Idx,
        mod_id: '',
        posterWidth,
        posterHeight,
      };
      poster.posterArr = handlePoster({
        posterArr: items.slice(0, posterEndIdx),
        isPoster: true,
        firstGet,
      });
      // 处理历史纪录模块数据
      if (firstGet) {
        // HomeTab历史记录取poster中的三条，前面加上historyTab
        history = {
          name,
          mod_pos: Idx,
          mod_id: '',
          posterWidth: posterWidthArr.History,
          posterHeight: posterHeightArr.History,
        };
        history.posterArr = handlePoster({
          posterArr: items.slice(posterEndIdx, posterEndIdx + posterLengthArr.History),
          isPoster: false,
          firstGet,
        });
        history.posterArr = [
          {
            posterType: 6,
          },
          ...history.posterArr,
        ];
      } else {
        // OtherTaber无历史记录信息
        history.posterArr = [];
      }
    } else if (type === 3) {
      // type 为 3 是下方普通模块的column信息
      if (items.length >= 4) {
        const columnItem = {
          curFocusIdx: 0,
          name,
          posterAction: '',
          posterWidth: posterWidthArr.Column,
          posterHeight: posterHeightArr.Column,
          mod_id: '',
        };
        // column模块不用区分页面
        columnItem.posterArr = handlePoster({
          posterArr: items.slice(0, posterLengthArr.Column),
          isPoster: false,
          firstGet,
        });
        columnItem.posterArr = [...columnItem.posterArr, {
          posterType: 7,
        }];
        column.push(columnItem);
      }
    }
  });
  return {
    poster,
    history,
    column,
  };
};

const handlePoster = ({ posterArr, isPoster, firstGet }) => {
  // 增加海报曝光点击上报
  // eslint-disable-next-line
  const posterType = isPoster && firstGet ? 1 : isPoster && !firstGet ? 5 : 2;
  // eslint-disable-next-line
  posterArr = posterArr.map((poster) => {
    const { id, cid, vid, labels, pic, subtitle, title, type } = poster;
    return { id, cid, vid, labels, pic, subtitle, title, type, posterType };
  });
  return posterArr;
};

const handleModuleColumn = (modules) => {
  const column = [];
  modules.forEach((module) => {
    const {
      // item_pic_aspect_ratio: ratio,
      name,
      // row_count: rowCount,
      items,
      type,
    } = module;
    if (type === 3) {
      // type 为 3 是下方普通模块的column信息
      if (items.length >= 4) {
        const columnItem = {
          curFocusIdx: 0,
          name,
          posterAction: '',
          posterWidth: posterWidthArr.Column,
          posterHeight: posterHeightArr.Column,
          mod_id: '',
        };
        // column模块不用区分页面
        columnItem.posterArr = handlePoster({
          posterArr: items.slice(0, posterLengthArr.Column),
          isPoster: false,
          firstGet: false,
        });
        columnItem.posterArr = [...columnItem.posterArr, {
          posterType: 7,
        }];
        column.push(columnItem);
      }
    }
  });
  return column;
};

// 获取localStorage中的navigations信息
export const getNavigations = (channelId) => {
  const navigations = JSON.parse(localStorage.getItem('navigations')) || {};
  return navigations[channelId] || {};
};

export const removeNavigations = () => {
  localStorage.removeItem('navigations');
};

const saveNavigations = ({ channelId, result }) => {
  let navigations = JSON.parse(localStorage.getItem('navigations')) || {};
  // 兜底以前的代码，之前的存储格式是数组
  if (isArray(navigations)) {
    removeNavigations();
    navigations = {};
  }
  navigations[channelId] = result;
  localStorage.setItem('navigations', JSON.stringify(navigations));
};

const getChannelId = ({
  firstGet,
  navigation,
  channelId,
}) => {
  if (channelId) return channelId;
  if (firstGet) return navigation[1]?.channel?.id || '';
  return '';
};
